import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import LeftSidebarCategoryDropdownItem from './LeftSidebarCategoryDropdownItem';
import LeftSidebarCategoryItem from './LeftSidebarCategoryItem';
import { SidebarCategory, SidebarCategoryDropdownItem, SidebarCategoryItem } from './SidebarCategoryTypes';

interface Props extends RouteComponentProps {
    category: SidebarCategory;
}

const isSidebarCategoryItem = (
    item: SidebarCategoryItem | SidebarCategoryDropdownItem
): item is SidebarCategoryItem => {
    return (item as SidebarCategoryItem).path !== undefined;
};

const isSidebarCategoryDropdownItem = (
    item: SidebarCategoryItem | SidebarCategoryDropdownItem
): item is SidebarCategoryDropdownItem => {
    return (item as SidebarCategoryDropdownItem).items !== undefined;
};

const LeftSidebarCategory = ({ category }: Props) => {
    return (
        <>
            <li className="nav-small-cap">
                <i className={`mdi ${category.showCategoryDots ? 'mdi-dots-horizontal' : ''}`} />
                <span className="hide-menu">{category.name}</span>
            </li>
            {category.items.map((item) => {
                if (isSidebarCategoryItem(item)) {
                    return <LeftSidebarCategoryItem item={item} key={item.name} />;
                }

                if (isSidebarCategoryDropdownItem(item)) {
                    return <LeftSidebarCategoryDropdownItem dropdownItem={item} key={item.name} />;
                }

                return null;
            })}
        </>
    );
};

export default withRouter(LeftSidebarCategory);
